/**
 * Onboarding Step Icons Map
 *
 * Maps onboarding step names to their corresponding Lucide icons.
 * Uses the 'name' field from OnboardingStep type (snake_case from API).
 */

import {
  Calendar,
  Settings,
  Blocks,
  Users,
  Siren,
  GitFork,
  MapPinHouse,
  Workflow,
  type LucideIcon,
} from 'lucide-react';
import { PagerDutyIcon } from '@/components/icons/PagerDutyIcon';

/**
 * Icon map for onboarding steps
 * Keys should match the 'name' field from OnboardingStep (step_name from API)
 */
export const ONBOARDING_STEP_ICONS: Record<string, LucideIcon | React.FC<any>> = {
  teams: MapPinHouse,
  users: Users,
  schedules: Calendar,
  services: GitFork,
  escalation_policies: Siren,
  incident_workflows: Workflow,
  aiops: Blocks,
  end: PagerDutyIcon,
};

/**
 * Get icon for a specific onboarding step
 * @param stepName - The step name (from OnboardingStep.name field)
 * @param fallbackIcon - Optional fallback icon if step name not found
 * @returns Lucide icon component
 */
export function getOnboardingStepIcon(
  stepName: string,
  fallbackIcon: LucideIcon = Settings,
): LucideIcon {
  const normalizedStepName = stepName.toLowerCase().replace(/\s+/g, '-');
  return ONBOARDING_STEP_ICONS[normalizedStepName] || fallbackIcon;
}
